import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./achievment.css";
import {
  achievementRow1,
  achievementRow2,
} from "./achievementsData";

export default function OurAchievements() {
  return (
    <Container className="mb-md-4 pb-md-3 my-sm-1 py-sm-1" fluid>
      <h2
        className="fw-bold text-center py-3"
        data-aos="fade-right"
      >
        Our Achievements
      </h2>

      {/* Row 1 */}
      <Row
        className="justify-content-center text-center mt-4"
        data-aos="fade-up"
      >
        {achievementRow1.map((item) => (
          <Col key={item.id} xs={6} sm={4} md={3} lg={3}>
            <div className="card-main">
              <div className="card-img">
                <img
                  src={item.image}
                  className="img-fluid"
                  alt={item.alt}
                />
              </div>
              <h4>{item.count}</h4>
              <p>{item.title}</p>
            </div>
          </Col>
        ))}
      </Row>

      {/* Row 2 */}
      <Row
        className="justify-content-center text-center mt-5"
        data-aos="fade-down"
      >
        {achievementRow2.map((item) => (
          <Col key={item.id} xs={6} sm={4} md={3} lg={3}>
            <div className="card-main">
              <div className="card-img">
                <img
                  src={item.image}
                  className="img-fluid"
                  alt={item.alt}
                />
              </div>
              <h4>{item.count}</h4>
              <p>{item.title}</p>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
}